import defaultMessages from 'ra-language-english';
var defaultI18nProvider = function (locale) { return defaultMessages; };
export default defaultI18nProvider;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/i18n/defaultI18nProvider.js
// module id = 930
// module chunks = 0